<template>
  <div id="overlay-list" class="bg-white full-height relative-position">
    <div
      class="full-width row items-center justify-center cursor-pointer q-pt-sm q-mb-sm q-px-md close-bar"
      @click="close"
    >
      <div class="bar q-my-xs cursor-pointer"></div>
    </div>

    <div class="text-right close-icon">
      <q-icon
        class="close"
        name="close"
        size="sm"
        color="grey"
        @click="close"
      />
    </div>

    <div
      class="overline text-grey-7 q-px-md"
      v-if="data.overline"
      ref="overline"
    >
      {{ data.overline }}
    </div>

    <div
      class="title text-grey-9 q-mt-xs q-px-md"
      v-if="data.title"
      ref="title"
    >
      {{ data.title }}
    </div>

    <div class="q-mt-md">
      <div ref="tabs">
        <q-tabs
          v-model="currentTab"
          v-if="tabs.length > 1"
          active-color="secondary"
          dense
        >
          <q-tab
            class="tab"
            :name="item.label"
            :label="item.label"
            v-for="(item, index) in tabs"
            :key="index"
          />
        </q-tabs>

        <q-separator />
      </div>

      <q-tab-panels
        v-model="currentTab"
        animated
        swipeable
        vertical
        transition-prev="jump-up"
        transition-next="jump-up"
      >
        <q-tab-panel
          class="q-pa-none"
          :name="item.label"
          v-for="(item, index) in tabs"
          :key="index"
        >
          <component
            :is="item.component ? item.component : 'DOverlayDatesList'"
            :listHeight="listHeight"
            :hashId="hashId"
            :data="item"
            :apiBaseUrl="apiBaseUrl"
            :cid="cid"
            v-bind="item.componentProps ? item.componentProps : {}"
          />
        </q-tab-panel>
      </q-tab-panels>
    </div>
  </div>
</template>

<script>
import DOverlayDatesListAsync from "./components/DOverlayDatesListAsync/DOverlayDatesListAsync.vue";
import DOverlayDatesList from "./components/DOverlayDatesList/DOverlayDatesList.vue";

export default {
  name: "DCardOverlayList",
  data() {
    return {
      currentTab: "",
      listHeight: "",
      pricesList: [],
      loading: false,
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    hashId: {
      type: String,
      required: false,
      default: null,
    },
    apiBaseUrl: {
      type: Object,
      required: false,
      default: () => {},
    },
    cid: {
      type: String,
      required: true,
    },
  },
  computed: {
    tabs: {
      get() {
        return typeof this.data.tabs === "string"
          ? JSON.parse(this.data.tabs)
          : this.data.tabs;
      },
    },
  },
  beforeMount() {
    this.currentTab = this.tabs[0].label;
  },
  async mounted() {
    const overline = this.$refs.overline?.scrollHeight ?? 0;
    const title = this.$refs.title?.scrollHeight ?? 0;
    const tabs = this.$refs.tabs?.scrollHeight ?? 0;
    this.listHeight = `${450 * 0.9 - (44 + overline + title + tabs) + 41}px`;
  },
  methods: {
    close() {
      this.$emit("close");
    },
    getList(tab) {
      return this.data.tabs.find((t) => t.label === tab).list;
    },
    getRowIcon(section, row) {
      if (section.icon) {
        return section.icon;
      }
      if (row.icon) {
        return row.icon;
      }
      return null;
    },
  },
  components: { DOverlayDatesListAsync, DOverlayDatesList },
};
</script>

<style lang="scss">
#overlay-list {
  letter-spacing: 0.2px;
  font-family: "Open Sans";
  font-style: normal;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  position: relative;

  .overline {
    font-size: 9px;
    font-weight: 800;
    line-height: 16px;
    opacity: 0.7;
  }

  .title {
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    text-transform: capitalize;
  }

  .close-icon {
    position: absolute;
    top: 12px;
    right: 12px;

    .close {
      cursor: pointer;
    }
  }

  .close-bar {
    position: relative;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    .bar {
      cursor: pointer;
      width: 40px;
      height: 4px;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 17px;
      opacity: 0.5;
    }
  }

  .tab {
    .q-tab__label {
      font-size: 12px;
      line-height: 20px;
      font-weight: 700;
    }
  }
}
</style>
